import log from 'salvo-lite/log'
import $ from 'jquery'
import 'slick-carousel'

class Slider {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.dataset.slider)
        this._sliderId = elem.dataset.sliderId
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)
        if (this._sliderId) {
            window.slickSliders = {}
            window.slickSliders[this._sliderId] = $(this._elem).slick(this._options)
        } else {
            $(this._elem).slick(this._options)
        }
    }
}

export default Slider



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slider.js